import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useSession } from '@/hooks/useSession';

export const Route = createFileRoute('/auth/login')({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = useNavigate();
	const { isAuthed, signIn, isDemo, hydrated, isLoading } = useSession();

	useEffect(() => {
		if (isLoading || !hydrated) return;
		if (!isAuthed && signIn && !isDemo) signIn();
		else {
			navigate({ to: '/home', search: { sectionId: 'NONE' } });
		}
	}, [isAuthed, hydrated, isLoading]);

	return null;
}
